import React from 'react'
import { LandingPageContainerProps } from './LandingPageContainer.interface'
import styles from './LandingPageContainer.module.scss'

const LandingPageContainer: React.FC<LandingPageContainerProps> = ({
  children,
  className,
  containerClasses,
}) => {
  // Outer Wrapper (w-full, !p-0, relative, and background/min-height styles via SCSS)
  const wrapperClasses = `${styles.pageWrapper} w-full !p-0 relative ${className || ''}`

  // Inner Max-Width Container
  // Applies max-width, horizontal centering (mx-auto), and fixed vertical padding
  const innerContainerClasses = `${styles.container} max-w-[1130px] py-[70px] my-0 mx-auto relative ${containerClasses || ''}`

  return (
    <main>
      <div className={wrapperClasses}>
        <div className={innerContainerClasses}>{children}</div>
      </div>
    </main>
  )
}

export default LandingPageContainer
